<template>
  <div id="mapContainer" class="z-10"></div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, defineProps, computed } from 'vue'
import L, { Map } from 'leaflet'
import markerIconPngRed from '../../images/retov/marker-icon.png'
import markerIconPngBlue from '../../images/viewmax/blue-marker.png'

// Typy dla propsów
interface Marker {
  lat: number;
  lng: number;
  type: string;
  title: string;
  street: string;
  city: string;
  phones: string;
  email: string;
  website: string;
}

// Definicja propsów
const props = defineProps<{
  markers: Marker[] | string;
  errors: string[] | string;
  defaultColor: string;
  zoom: number;
}>()

// Przekształcanie danych markers i errors
const parsedMarkers = computed(() => {
  return typeof props.markers === 'string' ? JSON.parse(props.markers) : props.markers;
})

const parsedErrors = computed(() => {
  return typeof props.errors === 'string' ? JSON.parse(props.errors) : props.errors;
})

// Inicjalizacja mapy
let map: InstanceType<typeof Map> | null = null

onMounted(() => {
  // Logowanie błędów (jeśli są)
  parsedErrors.value.forEach((el: string) => {
    console.log(el)
  })

  // Inicjalizacja mapy
  map = L.map('mapContainer').setView([52.04445704605205, 19.50340866809421], props.zoom)

  L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 18,
    minZoom: 6
  }).addTo(map)

  // Definicje ikon markerów
  const ashMarker = L.icon({
    iconUrl: markerIconPngRed,
    iconSize: [25, 41],
    iconAnchor: [12.5, 20.5],
  })

  const phMarker = L.icon({
    iconUrl: markerIconPngBlue,
    iconSize: [25, 41],
    iconAnchor: [12.5, 20.5],
  })

  const defaultMarker = L.icon({
    iconUrl: 'data:image/svg+xml;utf-8,' +
      encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="12" height="16" viewBox="0 0 15 18">' +
        '<path stroke="white" stroke-width="1.2" stroke-opacity="1" d="M7.5,0C5.0676,0,2.2297,1.4865,2.2297,5.2703&#xA;&#x9;C2.2297,7.8378,6.2838,13.5135,7.5,15c1.0811-1.4865,5.2703-7.027,5.2703-9.7297C12.7703,1.4865,9.9324,0,7.5,0z"/>' +
        '<path fill="' + 'green' + '" d="M7.5,0C5.0676,0,2.2297,1.4865,2.2297,5.2703&#xA;&#x9;C2.2297,7.8378,6.2838,13.5135,7.5,15c1.0811-1.4865,5.2703-7.027,5.2703-9.7297C12.7703,1.4865,9.9324,0,7.5,0z"/>' +
        '</svg>'),
    iconSize: [32, 42],
    iconAnchor: [16, 21],
  })

  // Funkcja do zwracania odpowiedniej ikony w zależności od typu
  const returnMarkerBasedOnType = (type: string) => {
    if (!type || type.length === 0) return defaultMarker;

    if (type.toLowerCase() === 'ash') return ashMarker;
    if (type.toLowerCase() === 'ph') return phMarker;

    return defaultMarker;
  }

  // Dodawanie markerów na mapie
  parsedMarkers.value.forEach((marker: Marker) => {
    L.marker([marker.lat, marker.lng], {
      icon: returnMarkerBasedOnType(marker.type)
    }).addTo(map).on('click', (e) => {
      L.popup()
        .setLatLng(e.latlng)
        .setContent(`<strong class="text-primary text-black">${marker.title}</strong><br>
          ${marker.street}<br>
          ${marker.city}<br>
          ${marker.phones}<br>
          <a class="text-primary text-black" href="mailto:${marker.email}">${marker.email}</a><br>
          <a class="text-primary text-black" href="${marker.website}">${marker.website}</a>
        `)
        .openOn(map)
    })
  })
})

onBeforeUnmount(() => {
  if (map) {
    map.remove()
  }
})
</script>

<style scoped>
#mapContainer {
    width: 100%;
    height: 50vh;
}
</style>
